import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    cityisLoading : false,
    city: [],
    totalCurrency: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    cityiscLoading:false,
    cityCstatus:"",
    cityCMessage:"",
    citydetails:{},
    cityismloading:false,
    citymstatus:"",
    citymmessage:"",
    cities: {},
    citydstatus:"",
    citydmessage:"",
    error:"",
    
};


const citySlice = createSlice({
    name: "citiesList",
    initialState,
    reducers:{
        getCityPending: (state) => {
            state.cityisLoading = true;
        },
        getCitySuccess: (state, { payload }) => {
            state.cityisLoading = false;
            state.city = payload;
            state.citydetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getCityFail: (state, { payload }) => {
            state.cityisLoading = false;
            state.error = payload;
        },
        createCityPending:(state,action) => {
            state.cityiscLoading=true;
        },
        createCitySuccess:(state,{payload}) => {
            state.cityiscLoading=false;
            state.cityCstatus="success";
            state.cityCMessage=payload;
            
        },
        createCityFail:(state,{payload}) => {
            state.cityiscLoading=false;
            state.cityCstatus="fail";
            //console.log('slice '+payload);
            state.cityCMessage=payload;
        },
        getSCityPending: (state) => {
            state.cityisLoading = true;
        },
        getSCitySuccess: (state, { payload }) => {
            state.cityisLoading = false;
            state.cities=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSCityFail: (state, { payload }) => {
            state.cityisLoading = false;
            state.error = payload;
        },
        modifyCityPending:(state,action) => {
            state.cityismloading=true;
            state.citymstatus="";
        },
        modifyCitySuccess:(state,{payload}) => {
            state.cityismloading=false;
            state.citymstatus="success";
           
            state.citymmessage="City Successfully Updated";
        },
        modifyCityFail:(state,{payload}) => {
            state.cityismloading=false;
            state.citymstatus="fail";
           // console.log('slice '+payload);
            state.citymmessage=payload;
        },
        deleteCityPending:(state,action) => {
            state.cityisLoading=true;
            state.citydstatus="";
        },
        deleteCitySuccess:(state,{payload}) => {
            state.cityisLoading=false;
            state.citydstatus="success";
            state.citydmessage="City Successfully Deleted";
        },
        deleteCityFail:(state,{payload}) => {
            state.cityisLoading=false;
            state.citydstatus="fail";
           // console.log('slice '+payload);
            state.citydmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = citySlice;

export const { getCityPending, getCitySuccess, getCityFail,getSCityPending, getSCitySuccess, getSCityFail, 
    createCityPending, createCitySuccess, createCityFail,
    modifyCityPending,modifyCitySuccess,modifyCityFail,
    deleteCityPending,deleteCitySuccess,deleteCityFail  } = actions;

export default reducer;
